module.exports = __webpack_public_path__ + "img/cosleep_guidance_img_subscribe4_cn@3x.88e50c9b.png";